import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { ChargePointHasLocation } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/charge-point/charge-point-has-location.enum';
import { useTranslation } from 'react-i18next';

export interface ChargePointHasLocationFilterStateControllerProps {
  value: boolean;
  onRemove: FilteredItemProps['onRemove'];
}

export const ChargePointHasLocationFilterStateController = ({
  value,
  onRemove,
}: ChargePointHasLocationFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const chargePointHasLocation = value
    ? ChargePointHasLocation.TRUE
    : ChargePointHasLocation.FALSE;

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem
      icon="location"
      label={t(
        `delmonicos-shared-sdk.outputs-charge-point-has-location.${chargePointHasLocation}`,
      )}
      onRemove={onRemove}
    />
  );
};
